import React from 'react';

const Issue = props => {
  const { image } = props.issue;
  
  const handleDelete = (event) => {
    event.stopPropagation();
    props.onDelete(event, props.issue);
  };

  const decodeHtmlEntities = (str) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  };

  const renderImage = (image) => {
    if (!image) return null;

    try {
      const decodedHtml = decodeHtmlEntities(image);
      const decodedImage = decodeURIComponent(decodedHtml);
      const imageData = decodedImage.startsWith('data:') 
        ? decodedImage 
        : `data:image/jpeg;base64,${decodedImage}`;

      return (
        <div className="image-container" style={{ 
          maxHeight: '150px',  // Fixed height for consistency
          overflow: 'hidden',  // Clip overflow
          position: 'relative' // For proper stacking
        }}>
          <img 
            src={imageData} 
            alt="Issue" 
            style={{ 
              width: '100%',
              height: 'auto',
              position: 'absolute', // Take image out of flow
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)', // Center the image
              objectFit: 'cover'
            }} 
            onError={(e) => {
              console.error('Image failed to load');
              e.target.style.display = 'none';
            }}
          />
        </div>
      );
    } catch (error) {
      console.error('Error rendering image:', error);
      return null;
    }
  };

  // Process the image data
  let imageSrc = null;
  if (image) {
    try {
      const decodedHtml = decodeHtmlEntities(image);
      const decodedImage = decodeURIComponent(decodedHtml);
      const imageData = decodedImage.startsWith('data:') 
        ? decodedImage 
        : `data:image/jpeg;base64,${decodedImage}`;

      imageSrc = imageData;
    } catch (error) {
      imageSrc = null;
    }
  }

  return (
    <div
      onClick={() => props.onSelect(props.issue)}
      style={{ 
        cursor: 'pointer',
        position: 'relative',
        height: '400px', // Fixed height for list items
        overflow: 'hidden'
      }}
      className={props.issue === props.selectedIssue ? 'm-3 p-4 issue_item selected' : 'm-3 p-4 issue_item'}>

      {window.location.hostname.indexOf('localhost') > 0 ? (
        <div className='d-flex justify-content-end z-n1'>
          <button type="button"
            className="delete-button btn btn-danger btn-sm position-absolute"
            onClick={handleDelete}>
            Delete
          </button>
        </div>
      ) : ''
      }

      <div className="issue-element" style={{ height: '100%', overflowY: 'auto' }}>
        <sup>
          SubId: {props.issue.id}
        </sup>
        <sup className="badge text-bg-secondary ms-1">{props.issue.status}</sup>
        <small className="text-secondary ms-2">Click to view details</small>

        <div className="mt-1 row py-1">
          <div className='col-4'>
            <b>Created On:</b>
            <br/>
            {new Date(props.issue.date).toLocaleDateString('en-US')}
          </div>

          <div className='col-6'>
            <b>Reporter's Name:</b>
            <br />
            <p>{props.issue.name}</p>
          </div>

          <div className='col-sm-12 col-md-12 col-lg-4 col-xl-4'>
            <b>Reporter's Email:</b>
            <br />
            <p>{props.issue.email}</p>
          </div>

          <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4">
            <b>Work Type:</b>
            <br />
            <p>{props.issue.worktype}</p>
          </div>
        
          <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4">
            <b>Address:</b>
            <br />
            <p>{props.issue.address}</p>
          </div>
        </div>

        <div className="mt-1">
          <b>Details:</b>
          <br />
          <p className='ps-2 lh-1'>{props.issue.description}</p>
        </div>

        {/* Evidence image, if available */}
        {image && (
          <div className="mt-1">
            <b>Evidence:</b>
            <br />
            {renderImage(image)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Issue;
